var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"snsLinks"},[_c('li',{on:{"click":function($event){return _vm.moveToPage(6)}}},[_c('img',{attrs:{"src":require("../assets/img/common/contact_icon.png"),"alt":"가맹점주님 공간"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }